import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import shareLink from "../../config/share-link";
import { copyToClipBoard } from "../../helper-methods";
import { ToastContainer } from "react-toastify";

const CopyLinkModal = ({ share, toggle, alias }) => {
  const _closeModal = () => {
    toggle();
  };

  const _shareLink = () => {
    copyToClipBoard("copy", shareLink.url.concat("/", alias));
    _closeModal();
  };

  return (
    <>
      <Modal centered isOpen={share} toggle={() => _closeModal()}>
        <ModalBody>
          {/* <Form>
        
        <div className="form-group">
          <Label> </Label>
        </div>
      </Form> */}
          <input
            className="fs-20 m-0 w-100"
            defaultValue={shareLink.url.concat("/", alias)}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            type="button"
            onClick={() => _shareLink(alias)}
          >
            Copy
          </Button>
        </ModalFooter>
      </Modal>
      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
export default CopyLinkModal;
